'use strict';

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlUtils = {
  addScript: function addScript(url, async, id, callback) {
    var script = void 0;
    if (url) {
      script = global.document.createElement('script');
      script.async = !(0, _isNil2.default)(async) ? async : true;
      script.type = 'text/javascript';
      script.src = url;

      if (id) {
        script.id = id;
      }

      if (callback) {
        script.onload = callback;
        script.onerror = callback;
      }

      var head = global.document.getElementsByTagName('head')[0];
      head.appendChild(script);
    }
    return script;
  },
  addScriptWithType: function addScriptWithType(url, type, async, id) {
    var script = void 0;
    if (url) {
      script = global.document.createElement('script');
      script.async = !(0, _isNil2.default)(async) ? async : true;
      if (type) {
        script.type = type;
      }
      script.src = url;
      if (id) {
        script.id = id;
      }

      var head = global.document.getElementsByTagName('head')[0];
      head.appendChild(script);
    }
    return script;
  },
  removeScriptById: function removeScriptById(id) {
    var script = global.document.getElementById(id);

    if (script && script.parentNode) {
      script.parentNode.removeChild(script);
    }
  },
  isAdSlotVisible: function isAdSlotVisible(slotElementId) {
    var element = global.document.querySelector('#' + slotElementId);
    if (!element) {
      return false;
    }
    var elPosition = element.getBoundingClientRect();
    return elPosition.top >= 0 && elPosition.left >= 0 && elPosition.bottom <= (global.window.innerHeight || global.document.documentElement.clientHeight) && elPosition.right <= (global.window.innerWidth || global.document.documentElement.clientWidth);
  }
};

module.exports = htmlUtils;